import React, { Component } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { Link } from 'react-router-dom';
import global from '../global';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { config } from '../../Constants';
import download from 'downloadjs';
import { Layout } from '../Layout';
import Spinner from '../Spinner';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
const { SearchBar } = Search;
const expandRow = {
    renderer: row => (
        <div>
            <p className="m-t-10">{`DP ID: ${row.NAME_CSV}`}</p>
        </div>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true
};


export class FormGridComplete extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            assignments: [],
            RemitterCode: '',
            url: '',
            columns: [{
                dataField: 'AssignmentCode',
                text: 'Assignment Code',
                hidden: true
            },
                {
                    dataField: 'PDFLoc',
                    text: 'PDFLoc',
                    hidden: true
                },
                {
                    dataField: 'UniqueIDNo',
                    text: 'UniqueIDNo',
                    hidden: true
                },
            {
                dataField: 'RemitterName',
                text: 'Remitter',
                headerAlign: 'center',
                sort: true,

                },
                {
                    dataField: 'EmailID',
                    text: 'Email',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'PAN',
                    text: 'PAN',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'DPID',
                    text: 'DP ID',
                    headerAlign: 'center',
                    sort: true,

                },
            {
                dataField: 'FinancialYear',
                text: 'Financial Year',
                headerAlign: 'center',
                align: 'center',
                sort: true,
            },
            {
                dataField: 'UpdatedOn',
                text: 'Declaration Date',
                headerAlign: 'center',
                align: 'center',
                sort: true,
            },
            {
                dataField: "Download",
                text: "Download",
                headerAlign: 'center',
                align: 'center',
                formatter: (rowContent, row) => {
                    return (
                        <div>
                            <button className="btn btn-primary p-10"
                                onClick={e => {
                                    e.persist();
                                    FormGridComplete.handleEdit(row.PDFLoc, row.UniqueIDNo)
                                }}> <FontAwesomeIcon icon="cloud-download-alt" /> </button>
                        </div>
                    )
                }
            },
            ],
            loading: false
        }
    }

    componentDidMount() {

        axios.get(global.UserManagement.GetSessionDetailsAPI)
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        RemitterCode: response.data.RemitterCode,
                        url: config.url.Web_URL + '/' + response.data.RemitterCode
                    });
                } else {
                    window.location.href = config.url.Web_URL + `/Error/404`;
                    return;
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get(global.Form15GH.GetForm15GHDeclarationDetailsAPI + '?Type=C',
            { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } },
            { responseType: 'json' })
            .then(response => {
                if (response.data.status) {
                    this.setState({
                        assignments: response.data.Form15GHDetails
                    });
                }
                else {
                    this.setState({
                        assignments: []
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    static handleEdit(rowContent1, rowContent2) {

        axios.get(global.Form15GH.DownloadDigiSignedPdfAPI + '?pdfLocation=' + rowContent1,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/pdf' },
                responseType: 'blob'
            })
            .then(response => {
                const content = response.headers['content-type'];
                const fileName = rowContent2 +'.pdf'
                download(response.data, fileName, content)
               
            })
            .catch(error => {
                console.log(error);
                
            });
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };


    render() {
        if (this.state.loading) return <Spinner />;
        let contentFooter = Layout.RenderFooter();
        const options = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.assignments.length
        };

        const contentTable = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="AssignmentCode"
                    columns={this.state.columns}
                    data={this.state.assignments}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                    expandRow={expandRow} />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );
        let content = Layout.RenderNavMenu()
        var url = config.url.API_URL;

        return (
            <div>
                <ReactNotification />
                {content}
                <div className="Nexdigm">
                    <ol className="breadcrumb btn-Nexdigm">
                        <li><a href={this.state.url + "/Dashboard?UT=" + window.btoa(this.state.RemitterCode.toUpperCase() == "NEXDIGM" ? "A" : "U")} className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                        <li><a className="text-white">Form 15 G/H Declaration</a></li>
                    </ol>
                </div>
                <div className="content-page">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="header-title m-b-10 ">Form 15 G/H Declaration </h4>

                            <PaginationProvider
                                pagination={
                                    paginationFactory(options)
                                }
                            >
                                {contentTable}
                            </PaginationProvider>

                        </div>
                    </div>
                </div>
                {contentFooter}
            </div>
        );
    }
}
